import { appendItemWithSeekToConditionResponse } from 'owa-mail-list-response-processor';
import { findItemWithSeekToInstanceKeyCondition } from 'owa-mail-store/lib/services/findItemWithSeekToInstanceKeyCondition';
import getMailItemSortByProperty from '../../../utils/tables/getMailItemSortByProperty';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { LOAD_MORE_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
import { onLoadMoreRowsFailed, onLoadMoreRowsSucceeded } from '../onLoadMoreRowsCompleted';
import {
    getBaseFolderId,
    getBaseServerFolderId,
    MailFolderTableQuery,
    TableView,
} from 'owa-mail-list-store';
import getHashtagsToInclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToInclude';
import getHashtagsToExclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToExclude';

/**
 * Load more items from the server
 * @param tableView to load
 */
export default function loadMoreItemsFromServer(tableView: TableView) {
    const lastItemIndex = tableView.rowKeys.length - 1;
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    findItemWithSeekToInstanceKeyCondition(
        getBaseFolderId(mailTableQuery),
        tableView.rowKeys[lastItemIndex],
        LOAD_MORE_ROW_COUNT,
        mailTableQuery.viewFilter,
        getMailItemSortByProperty(mailTableQuery),
        mailTableQuery.focusedViewFilter,
        mailTableQuery.requestShapeName,
        getMailboxInfoFromTableQuery(mailTableQuery).requestOptions,
        mailTableQuery.categoryName,
        getHashtagsToInclude(mailTableQuery.inboxClassificationFilter),
        getHashtagsToExclude(mailTableQuery.inboxClassificationFilter),
        getBaseServerFolderId(tableView, true /* returnNullIfSameAsFolderId */)
    ).then(
        responseMessage => {
            if (responseMessage.ResponseClass === 'Success') {
                onLoadMoreRowsSucceeded(
                    tableView,
                    responseMessage.RootFolder.Items,
                    responseMessage.RootFolder.TotalItemsInView,
                    appendItemWithSeekToConditionResponse
                );
            } else {
                onLoadMoreRowsFailed(tableView, responseMessage.ResponseCode);
            }
        },
        (error: any) => {
            onLoadMoreRowsFailed(tableView);
        }
    );
}
